(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kinahh-delivery-timeline"] && !Shopify.designMode) return;
  try {
    (() => {
const DAY = 86400000;
const zoneFormatters = new Map();
const CONFIG_KEYS = ['configured', 'timeZone', 'cutoffHour', 'cutoffMinute', 'dispatchMin', 'dispatchMax', 'transitMin', 'transitMax', 'workDays', 'holidays', 'locale', 'orderWithin', 'nextCutoff', 'relativeDays', 'updateNote', 'available', 'productId', 'blockId'];

function zoneFormatter(timeZone) {
  if (!zoneFormatters.has(timeZone)) {
    zoneFormatters.set(timeZone, new Intl.DateTimeFormat('en-CA', {
      timeZone, calendar: 'gregory', numberingSystem: 'latn', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    }));
  }
  return zoneFormatters.get(timeZone);
}

function zonedParts(epoch, timeZone) {
  return Object.fromEntries(zoneFormatter(timeZone).formatToParts(epoch).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
}

function wallEpoch(parts) {
  return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour || 0, parts.minute || 0, parts.second || 0);
}

function dateKey(date) {
  return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
}

function shiftDate(date, days) {
  const shifted = new Date(Date.UTC(date.year, date.month - 1, date.day + days));
  return { year: shifted.getUTCFullYear(), month: shifted.getUTCMonth() + 1, day: shifted.getUTCDate() };
}

function zonedDateTimeToEpoch(date, hour, minute, timeZone) {
  // Use the first repeated cutoff; move a nonexistent DST cutoff forward by its gap.
  const desired = { ...date, hour, minute, second: 0 };
  const wall = wallEpoch(desired);
  const offsets = new Set();
  for (const days of [-2, -1, 0, 1, 2]) {
    const sample = wall + days * DAY;
    offsets.add(wallEpoch(zonedParts(sample, timeZone)) - sample);
  }
  const candidates = [...offsets].map(offset => wall - offset);
  const exact = candidates.filter(epoch => wallEpoch(zonedParts(epoch, timeZone)) === wall);
  if (exact.length) return Math.min(...exact);
  const after = candidates.map(epoch => ({ epoch, delta: wallEpoch(zonedParts(epoch, timeZone)) - wall })).filter(candidate => candidate.delta > 0).sort((a, b) => a.delta - b.delta || a.epoch - b.epoch);
  if (!after.length) throw new RangeError('The local cutoff could not be resolved');
  return after[0].epoch;
}

function parseDeliveryConfig(input) {
  if (input.configured !== 'true' && input.configured !== true) return null;
  const config = { timeZone: input.timeZone, locale: input.locale || 'en', holidays: new Set(), workDays: new Set() };
  try {
    if (!config.timeZone) return null;
    zoneFormatter(config.timeZone).format(0);
    new Intl.DateTimeFormat(config.locale).format(0);
    for (const [key, min, max] of [['cutoffHour', 0, 24], ['cutoffMinute', 0, 59], ['dispatchMin', 0, 365], ['dispatchMax', 0, 365], ['transitMin', 1, 365], ['transitMax', 1, 365]]) {
      const raw = String(input[key] ?? '').trim();
      if (!/^\d+$/.test(raw)) return null;
      config[key] = Number(raw);
      if (config[key] < min || config[key] > max) return null;
    }
    if ((config.cutoffHour === 24 && config.cutoffMinute !== 0) || config.dispatchMax < config.dispatchMin || config.transitMax < config.transitMin) return null;
    for (const entry of String(input.workDays ?? '').split(',')) {
      const day = entry.trim();
      if (!/^[0-6]$/.test(day)) return null;
      config.workDays.add(Number(day));
    }
    for (const entry of String(input.holidays ?? '').split(/[\n,]/).map(value => value.trim()).filter(Boolean)) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(entry)) return null;
      const [year, month, day] = entry.split('-').map(Number);
      if (year < 100 || dateKey(shiftDate({ year, month, day }, 0)) !== entry) return null;
      config.holidays.add(entry);
    }
    return config;
  } catch {
    return null;
  }
}

function isWorkingDate(date, config) {
  return config.workDays.has(new Date(Date.UTC(date.year, date.month - 1, date.day)).getUTCDay()) && !config.holidays.has(dateKey(date));
}

function addWorkingDays(start, count, config) {
  // Zero is the processing date itself. Positive offsets count eligible dates after it.
  let date = { year: start.year, month: start.month, day: start.day };
  let remaining = count;
  for (let scanned = 0; remaining > 0; scanned += 1) {
    if (scanned > 6000) throw new RangeError('No eligible working date in range');
    date = shiftDate(date, 1);
    if (isWorkingDate(date, config)) remaining -= 1;
  }
  return date;
}

function getDeliveryTimeline(epoch, config) {
  if (!config || !Number.isFinite(Number(epoch))) return null;
  const now = Number(epoch);
  const today = zonedParts(now, config.timeZone);
  const todayCutoff = zonedDateTimeToEpoch(today, config.cutoffHour, config.cutoffMinute, config.timeZone);
  const orderWithin = isWorkingDate(today, config) && now < todayCutoff;
  const processingDate = orderWithin ? shiftDate(today, 0) : addWorkingDays(today, 1, config);
  const cutoff = orderWithin ? todayCutoff : zonedDateTimeToEpoch(processingDate, config.cutoffHour, config.cutoffMinute, config.timeZone);
  const windowStart = zonedDateTimeToEpoch(processingDate, 0, 0, config.timeZone);
  const dispatchStart = addWorkingDays(processingDate, config.dispatchMin, config);
  const dispatchEnd = addWorkingDays(processingDate, config.dispatchMax, config);
  const arrivalStart = addWorkingDays(dispatchStart, config.transitMin, config);
  const arrivalEnd = addWorkingDays(dispatchEnd, config.transitMax, config);
  const refreshAt = Math.min(cutoff, zonedDateTimeToEpoch(shiftDate(today, 1), 0, 0, config.timeZone));
  return { today: dateKey(today), year: today.year, processingDate, orderWithin, cutoff, windowStart, dispatchStart, dispatchEnd, arrivalStart, arrivalEnd, refreshAt };
}

function formatDateWindow(start, end, locale = 'en', referenceYear = start.year) {
  const includeYear = start.year !== end.year || start.year !== referenceYear || end.year !== referenceYear;
  const formatter = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'short', ...(includeYear ? { year: 'numeric' } : {}) });
  const first = new Date(wallEpoch(start));
  const last = new Date(wallEpoch(end));
  return first.getTime() === last.getTime() ? formatter.format(first) : formatter.formatRange(first, last);
}

function formatCountdown(milliseconds) {
  const seconds = Math.max(0, Math.ceil(milliseconds / 1000));
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
}

function formatRelativeDays(template, min, max) {
  return template.replaceAll('{min}', String(min)).replaceAll('{max}', String(max));
}

function cutoffProgress(epoch, timeline) {
  const duration = timeline.cutoff - timeline.windowStart;
  return duration > 0 ? Math.max(0, Math.min(100, ((epoch - timeline.windowStart) / duration) * 100)) : 0;
}

const ElementBase = globalThis.HTMLElement || class extends EventTarget {};
const normalizedId = value => String(value ?? '').split('/').pop();

class KinahhDeliveryTimeline extends ElementBase {
  #config;
  #timeline;
  #lastNow = 0;
  #timer;
  #observer;
  #section;
  #document;
  #visible = true;
  #generation = 0;
  #pendingSelection = false;
  #refs = {};
  #initial = {};
  #digitNodes = [];

  connectedCallback() {
    this.#pendingSelection = false;
    this.#visible = true;
    this.#document = this.ownerDocument;
    this.#section = this.closest('.shopify-section');
    this.#digitNodes = [];
    for (const [key, selector] of Object.entries({ countdown: 'countdown', label: 'countdown-label', timer: 'timer', digits: 'digits', timerText: 'timer-text', dispatch: 'dispatch', arrival: 'arrival', promise: 'arrival-promise', progress: 'progress', fallback: 'fallback' })) {
      this.#refs[key] = this.querySelector(`[data-delivery-${selector}]`);
    }
    this.#initial = { dispatch: this.#refs.dispatch?.textContent || '', arrival: this.#refs.arrival?.textContent || '' };
    this.#document?.addEventListener('visibilitychange', this.#onVisibility);
    this.#section?.addEventListener('shopify:product:select', this.#onProductSelect);
    if (globalThis.IntersectionObserver) {
      this.#visible = false;
      this.#observer = new IntersectionObserver(entries => {
        this.#visible = entries.some(entry => entry.isIntersecting);
        this.#refresh();
      });
      this.#observer.observe(this);
    }
    this.#reset();
  }

  disconnectedCallback() {
    this.#generation += 1;
    this.#stop();
    this.#observer?.disconnect();
    this.#document?.removeEventListener('visibilitychange', this.#onVisibility);
    this.#section?.removeEventListener('shopify:product:select', this.#onProductSelect);
  }

  #stop() {
    if (this.#timer !== undefined) clearTimeout(this.#timer);
    this.#timer = undefined;
  }

  #onVisibility = () => this.#refresh();

  #reset() {
    this.#stop();
    this.#timeline = null;
    this.#lastNow = 0;
    this.#config = parseDeliveryConfig(this.dataset);
    this.#refresh();
  }

  #fallback() {
    if (this.#refs.countdown) this.#refs.countdown.hidden = true;
    if (this.#refs.fallback) this.#refs.fallback.hidden = false;
    if (this.#refs.dispatch) this.#refs.dispatch.textContent = this.#initial.dispatch;
    if (this.#refs.arrival) this.#refs.arrival.textContent = this.#initial.arrival;
    if (this.#refs.progress) this.#refs.progress.style.width = '0%';
  }

  #renderCountdown(value) {
    if (this.#refs.digits) {
      if (this.#digitNodes.length !== value.length || this.#digitNodes.some(node => node.parentNode !== this.#refs.digits)) {
        this.#digitNodes = [...value].map(character => {
          const node = this.#document.createElement('span');
          node.className = character === ':' ? 'kinahh-delivery__separator' : 'kinahh-delivery__digit';
          return node;
        });
        this.#refs.digits.replaceChildren(...this.#digitNodes);
      }
      this.#digitNodes.forEach((node, index) => {
        if (node.textContent !== value[index]) node.textContent = value[index];
      });
      if (!this.#refs.timerText) this.#refs.timer?.setAttribute('aria-label', value);
    } else if (this.#refs.timer) this.#refs.timer.textContent = value;
    if (this.#refs.timerText && this.#refs.timerText.textContent !== value) this.#refs.timerText.textContent = value;
  }

  #refresh = () => {
    this.#stop();
    if (!this.isConnected) return;
    if (this.#pendingSelection) {
      this.hidden = true;
      return;
    }
    this.hidden = this.dataset.available !== 'true';
    if (this.hidden) return;
    if (!this.#config) {
      this.#fallback();
      return;
    }
    if (this.#document?.visibilityState === 'hidden') return;
    const now = Date.now();
    try {
      if (!this.#timeline || now >= this.#timeline.refreshAt || now < this.#lastNow) {
        this.#timeline = getDeliveryTimeline(now, this.#config);
        if (this.#refs.dispatch) this.#refs.dispatch.textContent = this.dataset.relativeDays
          ? formatRelativeDays(this.dataset.relativeDays, this.#config.dispatchMin, this.#config.dispatchMax)
          : formatDateWindow(this.#timeline.dispatchStart, this.#timeline.dispatchEnd, this.#config.locale, this.#timeline.year);
        if (this.#refs.arrival) this.#refs.arrival.textContent = this.dataset.relativeDays
          ? formatRelativeDays(this.dataset.relativeDays, this.#config.dispatchMin + this.#config.transitMin, this.#config.dispatchMax + this.#config.transitMax)
          : formatDateWindow(this.#timeline.arrivalStart, this.#timeline.arrivalEnd, this.#config.locale, this.#timeline.year);
        if (this.#refs.promise) {
          this.#refs.promise.textContent = new Intl.DateTimeFormat(this.#config.locale, { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(wallEpoch(this.#timeline.arrivalEnd));
          this.#refs.promise.dateTime = dateKey(this.#timeline.arrivalEnd);
        }
        if (this.#refs.label) this.#refs.label.textContent = this.#timeline.orderWithin ? this.dataset.orderWithin : this.dataset.nextCutoff;
      }
      this.#lastNow = now;
      this.#renderCountdown(formatCountdown(this.#timeline.cutoff - now));
      if (this.#refs.progress) this.#refs.progress.style.width = `${cutoffProgress(now, this.#timeline).toFixed(2)}%`;
      if (this.#refs.countdown) this.#refs.countdown.hidden = false;
      if (this.#refs.fallback) this.#refs.fallback.hidden = true;
      if (this.#visible) this.#timer = setTimeout(this.#refresh, 1000);
    } catch {
      this.#config = null;
      this.#fallback();
    }
  };

  #onProductSelect = event => {
    if (event.target?.closest?.('product-card') || !event.promise?.then) return;
    const generation = ++this.#generation;
    this.#pendingSelection = true;
    this.#stop();
    this.hidden = true;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || generation !== this.#generation || !detail?.html) return;
      const productId = normalizedId(detail.newProduct?.id || detail.productId || this.dataset.productId);
      if (!detail.newProduct && productId !== normalizedId(this.dataset.productId)) {
        this.#pendingSelection = false;
        this.#refresh();
        return;
      }
      const fresh = [...detail.html.querySelectorAll('kinahh-delivery-timeline')].find(node => node.dataset.blockId === this.dataset.blockId && normalizedId(node.dataset.productId) === productId);
      if (!fresh) return;
      for (const key of CONFIG_KEYS) {
        if (fresh.dataset[key] === undefined) delete this.dataset[key];
        else this.dataset[key] = fresh.dataset[key];
      }
      if (detail.resource === null) this.dataset.available = 'false';
      this.#initial.dispatch = fresh.querySelector('[data-delivery-dispatch]')?.textContent || this.#initial.dispatch;
      this.#initial.arrival = fresh.querySelector('[data-delivery-arrival]')?.textContent || this.#initial.arrival;
      this.#pendingSelection = false;
      this.#reset();
    }).catch(() => {
      if (generation === this.#generation) this.#stop();
    });
  };
}

if (globalThis.customElements && !customElements.get('kinahh-delivery-timeline')) {
  customElements.define('kinahh-delivery-timeline', KinahhDeliveryTimeline);
}

})();
  } catch(e) { console.error(e); }
})();

})();
